import { useEffect, useState } from "react";
import { isSignedIn, isPendingApproval, getRefreshToken } from "./lib/auth.js";
import { refreshTokens, isCognitoConfigured } from "./lib/cognito.js";
import { Login } from "./components/Login.js";
import { Shell } from "./components/Shell.js";
import { PendingApprovalScreen } from "./components/PendingApprovalScreen.js";
import { useGlobalEscapeToClear } from "./lib/clearOnEscape.js";

export function App() {
  useGlobalEscapeToClear();
  const [signedIn, setSignedIn] = useState(false);
  const [pending,  setPending]  = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    void checkSession();
  }, []);

  async function checkSession() {
    // If the access token is missing/expired but a refresh token is still
    // present (now persisted in localStorage), silently renew the session
    // before falling back to the Login screen. The Cognito refresh token is
    // valid for 30 days, so an active user rarely needs to re-enter credentials.
    if (!isSignedIn() && isCognitoConfigured() && getRefreshToken()) {
      await refreshTokens().catch(() => false);
    }

    if (isSignedIn()) {
      setPending(isPendingApproval());
      setSignedIn(!isPendingApproval());
    } else {
      setPending(false);
      setSignedIn(false);
    }
    setChecking(false);
  }

  // Avoid flashing the Login screen while a silent refresh is in flight.
  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-gray-400">
        Loading…
      </div>
    );
  }

  if (pending) {
    return (
      <PendingApprovalScreen
        onCheckAgain={() => {
          setPending(false);
          void checkSession();
        }}
        onSignOut={() => {
          setPending(false);
          setSignedIn(false);
        }}
      />
    );
  }

  if (!signedIn) return <Login onSignedIn={() => { void checkSession(); }} />;
  return <Shell onSignOut={() => setSignedIn(false)} />;
}
